<template>
  <PassTransparencyDataTable />
</template>
<script>
import PassTransparencyDataTable from "@/v3components/Datatables/PassTransparencyDataTable.vue"
export default {
  name: "PassTransparency",
  components: { PassTransparencyDataTable }
}
</script>
